/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, getPreferedMaxDialogHeight, closeDialog } from './dialog-util.js';
import { showWarningToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDLocale } from './locale-impl.js';

import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';
import { htmlspecialchars } from './util.js';


export let MVDownload = function($,mj) {

	var m_mdl_form = null,
		archive_autostart = true,
		archive_id = null;

	function create_archive( mdl_list ) {
		var dlf_selects = $('#mdl-zip-format-list div[id^=mdl-zip-format-] select');
		// update view
		dlf_selects.prop('disabled',true);
		$('#mdl-zip-create-button').hide();
		$('#mdl-zip-download-button').hide();
		$('#mdl-zip-progress')
			.html('<img src="'+htmlspecialchars(mj.skin_files['ajax-loader'],true,true)+'" align="top" style="margin-right:10px" /> '+mjt('mdl-zip-progress-wait'))
			.show();
		// get selected formats
		archive_id = null;
		var archive_formats = {}; // media_class => dlf_id
		dlf_selects.each( function() {
			var media_class = $(this).closest('.mdl-zip-format').attr('id').substr(15);
			var dlf_id = this.options[this.selectedIndex].value;
			archive_formats[media_class] = dlf_id;
		} );
		// combine media_ids and download formats
		var tmp = {};
		$('.mdl-item:not(.disabled)',mdl_list).each( function() {
			var self = $(this);
			var media_class = self.data('media_class');
			if( media_class in archive_formats ) {
				var dlf_id = archive_formats[media_class];
				var media_id = self.data('media_id');
				if( dlf_id in tmp ) tmp[dlf_id].push(media_id);
				else tmp[dlf_id] = [media_id];
			}
		} );
		var items = [];
		for( var dlf_id in tmp ) {
			if( !tmp.hasOwnProperty(dlf_id) ) continue;
			items.push(dlf_id+':'+tmp[dlf_id].join(','));
		}
		// create ...
		$.postJSON2('json/media/archive-create', 'items='+encodeURIComponent(items.join(';')), function(j) {
			// success callback
			archive_id = j.archive_id;
			var check_archive_ready = function( initial ) {
				if( initial || ( m_mdl_form!==null && m_mdl_form.hasClass('ui-dialog-content') && m_mdl_form.dialog('isOpen') ) ) {
					if( archive_id==null ) return; // ignore
					$.postJSON2(
						'json/media/archive-ready/id/'+encodeURIComponent(archive_id),
						'',
						function(j) {
							var dlf_selects = $('#mdl-zip-format-list div[id^=mdl-zip-format-] select');
							if( j.ready && j.ready=='1' ) {
								$('#mdl-zip-progress').hide();
								dlf_selects.prop('disabled',false);

								var dl_fn = archive_id+'.zip';
								var dl_url = mj.webroot+'media/media/archive-get/id/'+encodeURIComponent(archive_id)+'/fn/'+encodeURIComponent(dl_fn);
								$('#mdl-zip-download-button')
									.attr({href:dl_url,target:'_parent',download:dl_fn})
									.show();

							} else if( j.error ) {
								// stop
								dlf_selects.prop('disabled',false);
								$('#mdl-zip-create-button').show();
								$('#mdl-zip-progress').text( mjt('mdl-zip-failed') );
							} else {
								// check again
								setTimeout( function() {
									check_archive_ready(false);
								}, 500 );
							}
						},
						function() {
							// timeout from server
							setTimeout( function() {
								check_archive_ready(false);
							}, 1000 );
						},
						function() {
							// error from server
							setTimeout( function() {
								check_archive_ready(false);
							}, 1000 );
						}
					);
				}
			};
			check_archive_ready( true );
		}, function() {
			// timeout callback
			dlf_selects.prop('disabled',false);
		}, function() {
			// error callback
			dlf_selects.prop('disabled',false);
		});

	}

	function get_download_url( media_id, format, filename ) {
		return mj.fixAssetURL(
			mj.webroot+'media/file/download/format/'+encodeURIComponent(format)+'/id/'+media_id.toString()
				+ ( filename ? ('/fn/'+encodeURIComponent(filename)) : '' )
				+ '?' + encodeURIComponent(Date.now())
		);
	}

	function open( media_ids ) {
		if( media_ids.length===0 ) return;
		archive_id = null;
		if( m_mdl_form===null ) m_mdl_form = $('#mdl-form');
		m_mdl_form.dialog('destroy').hide();

		$('#mdl-multi,#mdl-single,#mdl-none').hide();
		$('#mdl-zip-create-button,#mdl-zip-download-button,#mdl-zip-progress').hide();
		var mdl_item_template = $('#mdl-item-template');
		var mdl_list = $('#mdl-list').empty().detach();
		startProgress();
		// clear list
		//$('[id^=mdl-file-]',mdl_list).remove();
		// load meta data
		var postdata = 'media_ids='+encodeURIComponent(media_ids.join(','));
		$.postJSON('json/media/meta-dlinfo', postdata, function _meta_dlinfo_response(j) {
			stopProgress();

			var available_count = 0,
				mid_by_dlf_by_mc = {},
				media_ids_len = media_ids.length;
			var dlf, idx;
			if( media_ids_len ) {
				var j_formats_len = j.formats.length;
				var file_nodes = [];
				for( var i=0; i<media_ids_len; ++i ) {
					var mid = media_ids[i],
						meta = j.meta && j.meta[mid] ? j.meta[mid] : [],
						filename = meta[1] ? meta[1][0] : '',
						filesize = meta[5] ? MDLocale.fmt_filesize(meta[5][0]) : '',
						filename_text = htmlspecialchars(filename) + ( filesize ? ' ('+filesize+')' : '' ),
						media_class = meta[-1] ? meta[-1][0] : 0,
						title = meta[101] ? meta[101][0] : '';
					title = title=='' ? 'ID '+mid : title+' (ID '+mid+')';

					var file_node = mdl_item_template.clone(false)
						.attr( { id:'mdl-file-'+mid } )
						.data( { media_id:mid, media_class:media_class } )
						.find('.mdl-item-media-id').text(title).end()
						.find('.mdl-item-filename').html(filename_text).end()
						.show();
					//.appendTo( mdl_list );

					MThumbnails.createOnTarget(
						file_node.children('.mdl-item-thumb')[0],
						{
							media_id: mid,
							width: 55,
							height: 45,
							meta: meta,
							thumb_loader_anim:true,
						}
					);

					if( mid in j.perms && Object.size(j.perms[mid]) > 0 ) {


						// TODO: move to plugin...
						if( mid in j.disabled_by_not_yet_incepted && j.disabled_by_not_yet_incepted[mid] ) {
							file_node.addClass('disabled').find('.mdl-item-na-not-yet-incepted').show();
						} else if( mid in j.disabled_by_expiry && j.disabled_by_expiry[mid] ) {
							file_node.addClass('disabled').find('.mdl-item-na-expired').show();
						} else {


							var menu = file_node.find('.mdl-item-menu'),
								menu_td = menu.find('td'),
								dl_link_template = menu_td.find('.mdl-item-dl-link:first').remove(),
								dl_links = [];
							for( var dlf_idx=0; dlf_idx<j_formats_len; ++dlf_idx ) {
								dlf = j.formats[dlf_idx];
								if( dlf.media_class==media_class ) {
									var dl_filename = j.filenames[mid][dlf.id];
									var dl_link = dl_link_template.clone(false)
										.data( { dlf_id:dlf.id, filename:dl_filename } )
										.text(dlf.name);
									//.appendTo(menu_td);

									if( j.perms[mid][dlf.acl_action] ) {
										// remember media_class->dlf->media_count info for zip archive code..
										if( media_class in mid_by_dlf_by_mc ) {
											if( dlf.id in mid_by_dlf_by_mc[media_class] ) mid_by_dlf_by_mc[media_class][dlf.id] ++;
											else mid_by_dlf_by_mc[media_class][dlf.id] = 1;
										} else {
											mid_by_dlf_by_mc[media_class] = {};
											mid_by_dlf_by_mc[media_class][dlf.id] = 1;
										}
										// direct link
										dl_link.html( $('<a>',{href:get_download_url(mid,dlf.id,dl_filename),target:'_parent',download:dl_filename}).text(dlf.name) );
									} else {
										dl_link.removeClass('emph-link').addClass('disabled');
									}

									dl_links.push(dl_link);
								}
							}
							menu_td.append(dl_links);
							menu.show();
							available_count ++;


						}
					} else {
						file_node.addClass('disabled').find('.mdl-item-na').show();
					}
					file_nodes.push(file_node);
				}
				mdl_list.append(file_nodes);

				// zip archive
				if( media_ids_len > 1 ) {
					if( available_count > 1 ) {
						if( available_count > 500 ) {
							showWarningToast( mjt('mdl-err-too-many-files-for-zip') );
						} else {
							$('#mdl-multi').show();
							// download formats by dlf_id
							var dlfs_hashed = {};
							for( idx=0; idx<j_formats_len; ++idx ) {
								dlf = j.formats[idx];
								dlfs_hashed[dlf.id] = dlf;
							}
							// add a select box for each available media_class
							$('#mdl-zip-format-list').empty();
							var mc_do_len = mj.mc_display_order.length;
							for( idx=0; idx<mc_do_len; ++idx ) {
								var mc = mj.mc_display_order[idx];
								if( mc in mid_by_dlf_by_mc ) {
									$('#mdl-zip-format-template').clone(false)
										.attr('id','mdl-zip-format-'+mc)
										.find('.label').text(mj.mc_names[mc]+': ').end()
										.find('select').attr('name','mdl-zip-mc-'+mc).end()
										.appendTo('#mdl-zip-format-list')
										.show();
									// add an option for each available download format
									for( var dlf_id in mid_by_dlf_by_mc[mc] ) {
										if( !mid_by_dlf_by_mc[mc].hasOwnProperty(dlf_id) ) continue;
										dlf = dlfs_hashed[dlf_id];
										var media_count = mid_by_dlf_by_mc[mc][dlf_id];
										if( media_count > 0 ) {
											var display_text = dlf.name;
											display_text += media_count==1 ? ' '+mjt('mdl-zip-files-per-df-1') : ( ' '+mjt('mdl-zip-files-per-df').replace('%d',media_count.toString()) );
											$('<option />').attr('value',dlf_id).attr('position', dlf.sort).text(display_text).appendTo('#mdl-zip-format-'+mc+' select');
										}
									}
								}
							}
							if( Object.size(mid_by_dlf_by_mc) > 0 ) {
								// zip format selection logic
								$('#mdl-zip-format-list div[id^=mdl-zip-format-] select')
									.change( function() {
										var self = $(this);
										if( self.prop('disabled') ) return; // should not happen, but just skip..
										if( archive_autostart ) {
											create_archive(mdl_list);
										} else {
											$('#mdl-zip-download-button').hide();
											$('#mdl-zip-create-button').show();
										}
									} )
									.select2({
										sorter: data => data.sort((a, b) => $(a.element).attr('position') < $(b.element).attr('position') ? -1 : 1)
									})
								;
								// autostart archive creation
								archive_autostart = true;
								if( 2 in mid_by_dlf_by_mc ) archive_autostart = false;	// disable autostart for videos
								if( available_count > 10 ) archive_autostart = false;	// disable autostart for more than 10 files
								if( archive_autostart ) {
									create_archive(mdl_list);
								} else {
									$('#mdl-zip-create-button').off('click').click( function() {
										create_archive(mdl_list);
									} ).show();
								}
							}
							// autofocus first <select> (this is way faster than the automatic detection...)
							$('#mdl-zip-format-list div[id^=mdl-zip-format-] select').first().attr('autofocus',true);
						}
					} else {
						$('#mdl-single').show();
					}
				} else {
					// single file available
					$('#mdl-single').show();
				}
			} else {
				// no files available
				$('#mdl-none').show();
			}

			// show dialog
			m_mdl_form.dialog( {
				//width:mw, height:mh,
				width:		function(win_size) {
					return Math.min(getPreferedMaxDialogWidth()-40,600);
				},
				height:		function(win_size) {
					return Math.min(getPreferedMaxDialogHeight()+0,1200);
				},
				modal:true,
				resizable:false,
				closeOnEscape:false,
				open:function() {
					mdl_list.insertBefore(mdl_item_template);
				},
				close:function(ev, ui) {
					$(this).dialog('destroy');
				},
			} ).show();

			m_mdl_form.dialog('option','height', function(win_size) {
				var mh = Math.min(getPreferedMaxDialogHeight()+0,1200);
				var oh = 90 + ($('#mdl-multi,#mdl-single,#mdl-none').filter(':visible').height()||0) + mdl_list.height();
				if( oh > mh ) oh = mh;
				else if( oh < 140 ) oh = 140;
				return oh;
			});
			$(document)
				.off('.MVDownload')
				.on('keydown.MVDownload', function(e) {
					if( $('#mj-widget-overlay,#page-blocking-overlay,#progress').is(':visible') ) return true;
					switch( e.which ) {
					case 27: // ESCAPE
						//if( !e.isDefaultPrevented() ) {
						closeDialog( m_mdl_form );
						e.preventDefault();
						e.stopPropagation();
						return false;
						//}
					}
				} );
			// re-start gif-anim
			$('#mdl-zip-progress').find('img').attr('src',mj.skin_files['ajax-loader']);
		});
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_download',open),
	};

}(jQuery,mj); // namespace MVDownload
